import React from 'react';

const squares = [
  <>
    <g clipPath="url(#clip0_9260_115408)">
      <mask
        id="mask0_9260_115408"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-24"
        y="3"
        width="76"
        height="78"
      >
        <rect
          x="-23.8364"
          y="23.0923"
          width="28.207"
          height="80.1102"
          transform="rotate(-43.8332 -23.8364 23.0923)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask0_9260_115408)">
        <rect
          x="-23.8364"
          y="23.0923"
          width="28.207"
          height="80.1102"
          transform="rotate(-43.8332 -23.8364 23.0923)"
          fill="#FFAB00"
        />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path
            d="M41.4756 -3.24467L66.5557 20.8002L22.3611 66.8974L-2.71888 42.8525C-2.71888 42.8525 -3.2185 34.4075 9.81872 26.9075C22.8559 19.4075 41.4756 -3.24467 41.4756 -3.24467Z"
            fill="#99D1FF"
          />
        </g>
      </g>
      <mask
        id="mask1_9260_115408"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-11"
        y="-28"
        width="83"
        height="84"
      >
        <rect
          x="-10.6807"
          y="-2.23801"
          width="36.4065"
          height="80.1102"
          transform="rotate(-43.8332 -10.6807 -2.23801)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask1_9260_115408)">
        <rect
          x="-19.6812"
          y="-2.23799"
          width="43.7288"
          height="80.1102"
          transform="rotate(-43.8332 -19.6812 -2.23799)"
          fill="#99D1FF"
        />
        <path
          d="M42.476 -3.24471L67.5561 20.8001L23.3615 66.8973L-6.68082 35.9075C-6.68082 35.9075 8.31856 28.9075 21.3188 18.9075C34.3191 8.90745 42.476 -3.24471 42.476 -3.24471Z"
          fill="#FFD666"
        />
        <g style={{ mixBlendMode: 'multiply' }}>
          <circle cx="44.8188" cy="47.4075" r="28.5" fill="#FCA9A1" />
        </g>
        <rect x="-12.6812" y="-1.09254" width="27" height="48" fill="#002B93" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9260_115408">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6V38C44 41.3137 41.3137 44 38 44H6C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9292_115397)">
      <mask
        id="mask0_9292_115397"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-14"
        y="15"
        width="86"
        height="48"
      >
        <rect
          x="-6.70117"
          y="62.1028"
          width="28.207"
          height="80.1102"
          transform="rotate(-103.833 -6.70117 62.1028)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask0_9292_115397)">
        <rect
          x="-9.11279"
          y="62.3334"
          width="28.207"
          height="80.1102"
          transform="rotate(-103.833 -9.11279 62.3334)"
          fill="#452CAB"
        />
        <path
          d="M-6.00099 44.1149L24.5002 45L45.0002 20L51.8256 49.0409L-0.175833 64.1558C-0.175833 64.1558 -9.98748 65.0507 -4.98754 58.6841C0.0124004 52.3176 -6.00099 44.1149 -6.00099 44.1149Z"
          fill="#FFD666"
        />
      </g>
      <mask
        id="mask1_9292_115397"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-33"
        y="-17"
        width="88"
        height="56"
      >
        <rect
          x="-23.4258"
          y="38.4104"
          width="36.4065"
          height="80.1102"
          transform="rotate(-103.833 -23.4258 38.4104)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask1_9292_115397)">
        <rect
          x="-34.5444"
          y="46.6146"
          width="43.7288"
          height="80.1102"
          transform="rotate(-103.833 -34.5444 46.6146)"
          fill="#FFD666"
        />
        <path
          d="M8.28011 -8.12795L41.6436 -17.8255L59.4676 43.4967L17.6084 54.0192C17.6084 54.0192 19.2961 37.0961 17.136 20.8375C14.9759 4.57893 8.28011 -8.12795 8.28011 -8.12795Z"
          fill="#FFAB00"
        />
        <ellipse
          cx="40.5327"
          cy="-7.74242"
          rx="29.5503"
          ry="30.3022"
          transform="rotate(-60 40.5327 -7.74242)"
          fill="#A081F4"
        />
        <path d="M-27.1665 35.1799L-4.12864 16.3209L30.2844 34.4716L14.4027 59.1799L-27.1665 35.1799Z" fill="#A081F4" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9292_115397">
        <path
          d="M-5.24537e-07 6C-2.34843e-07 2.68629 2.68629 2.34843e-07 6 5.24537e-07L38 3.32207e-06C41.3137 3.61176e-06 44 2.6863 44 6L44 38C44 41.3137 41.3137 44 38 44L6 44C2.68629 44 -3.61176e-06 41.3137 -3.32207e-06 38L-5.24537e-07 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9260_115455)">
      <mask
        id="mask0_9260_115455"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-8"
        y="-37"
        width="77"
        height="79"
      >
        <rect
          x="68.0625"
          y="21.4962"
          width="28.207"
          height="80.1102"
          transform="rotate(136.167 68.0625 21.4962)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask0_9260_115455)">
        <rect
          x="67.7358"
          y="24.4692"
          width="28.207"
          height="80.1102"
          transform="rotate(136.167 67.7358 24.4692)"
          fill="#FFC63F"
        />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path
            d="M2.75044 47.8331L-22.3296 23.7883L21.8649 -22.3089L46.945 1.73594C46.945 1.73594 47.4446 10.181 34.4074 17.681C21.3701 25.181 2.75044 47.8331 2.75044 47.8331Z"
            fill="#FFC63F"
          />
        </g>
      </g>
      <mask
        id="mask1_9260_115455"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-26"
        y="-10"
        width="82"
        height="84"
      >
        <rect
          x="55.9067"
          y="47.8265"
          width="36.4065"
          height="80.1102"
          transform="rotate(136.167 55.9067 47.8265)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask1_9260_115455)">
        <rect
          x="64.9072"
          y="47.8265"
          width="43.7288"
          height="80.1102"
          transform="rotate(136.167 64.9072 47.8265)"
          fill="#48DC37"
        />
        <path
          d="M2.75005 48.8332L-22.33 24.7883L21.8645 -21.3089L51.9069 9.68102C51.9069 9.68102 36.4072 16.681 23.4069 26.681C10.4066 36.681 2.75005 48.8332 2.75005 48.8332Z"
          fill="#0FBB0C"
        />
        <circle cx="-16.5928" cy="18.1808" r="28.5" transform="rotate(-180 -16.5928 18.1808)" fill="#FFC63F" />
        <rect x="61.9072" y="48.6808" width="24" height="48" transform="rotate(-180 61.9072 48.6808)" fill="#7AED5F" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9260_115455">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6V38C44 41.3137 41.3137 44 38 44H6C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9260_115444)">
      <mask
        id="mask0_9260_115444"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-36"
        y="-25"
        width="78"
        height="77"
      >
        <rect
          x="21.8149"
          y="-24.1553"
          width="28.207"
          height="80.1102"
          transform="rotate(46.1668 21.8149 -24.1553)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask0_9260_115444)">
        <rect
          x="21.8657"
          y="-20.2933"
          width="41.09"
          height="80.1102"
          transform="rotate(46.1668 21.8657 -20.2933)"
          fill="#FFC63F"
        />
        <g style={{ mixBlendMode: 'lighten' }}>
          <path
            d="M68.9089 30.449L29.5737 71.4777L-21.99 22.0423L17.3452 -18.9864C17.3452 -18.9864 29.0133 -21.8624 35.8917 -5.70313C42.7701 10.4562 68.9089 30.449 68.9089 30.449Z"
            fill="#7D58EE"
          />
        </g>
        <g style={{ mixBlendMode: 'multiply' }}>
          <rect x="-6" y="-11" width="29" height="48" fill="#002B93" />
        </g>
      </g>
      <mask
        id="mask1_9260_115444"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-11"
        y="-11"
        width="84"
        height="82"
      >
        <rect
          x="47.1455"
          y="-10.9994"
          width="36.4065"
          height="80.1102"
          transform="rotate(46.1668 47.1455 -10.9994)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask1_9260_115444)">
        <rect
          x="47.1455"
          y="-19.9998"
          width="43.7288"
          height="80.1102"
          transform="rotate(46.1668 47.1455 -19.9998)"
          fill="#99D1FF"
        />
        <g style={{ mixBlendMode: 'multiply' }}>
          <path
            d="M66.1524 42.1572L42.1075 67.2372L-3.98968 23.0427L42.1075 -10C42.1075 -10 34.0002 8.50004 44.0002 21.5003C54.0002 34.5006 66.1524 42.1572 66.1524 42.1572Z"
            fill="#006CFF"
          />
        </g>
        <path
          d="M36.0004 75L30.5242 82.5603L-22.9998 31.2455L23.5 11.5C23.5 11.5 8.61458 32.1917 20.5004 47C32.3862 61.8083 36.0004 75 36.0004 75Z"
          fill="#FFAB00"
        />
        <path
          d="M39.2537 26C30.005 26 23 18.9174 23 11.4615C23 4.00569 30.005 -1 39.2537 -1C48.5024 -1 56 5.04416 56 12.5C56 19.9558 48.5024 26 39.2537 26Z"
          fill="#FCA9A1"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9260_115444">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6L44 38C44 41.3137 41.3137 44 38 44L6 44C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9292_115420)">
      <mask
        id="mask0_9292_115420"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-19"
        y="-11"
        width="55"
        height="87"
      >
        <rect
          x="35.5303"
          y="67.1414"
          width="36.4065"
          height="80.1102"
          transform="rotate(166.167 35.5303 67.1414)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask0_9292_115420)">
        <rect
          x="46.7349"
          y="78.2598"
          width="43.7288"
          height="80.1102"
          transform="rotate(166.167 46.7349 78.2598)"
          fill="#F87173"
        />
        <path
          d="M-11.0078 25.4352L-20.7053 -7.92824L40.6169 -25.7523L51.1394 16.1069C51.1394 16.1069 34.2163 14.4192 17.9577 16.5793C1.69908 18.7394 -11.0078 25.4352 -11.0078 25.4352Z"
          fill="#FFAB00"
        />
        <path d="M11.8774 51.5656L-25.0495 27.8031L-14.3615 -13.6948L27.7376 1.16935L11.8774 51.5656Z" fill="#FFC63F" />
      </g>
      <g style={{ mixBlendMode: 'multiply' }}>
        <ellipse
          cx="18.8625"
          cy="5.73293"
          rx="29.5503"
          ry="30.3022"
          transform="rotate(-150 18.8625 5.73293)"
          fill="#FFAB00"
        />
      </g>
      <mask
        id="mask1_9292_115420"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="-28"
        width="53"
        height="86"
      >
        <rect
          x="61.1309"
          y="49.0896"
          width="30.0514"
          height="80.1102"
          transform="rotate(163.029 61.1309 49.0896)"
          fill="#006CFF"
        />
      </mask>
      <g mask="url(#mask1_9292_115420)">
        <rect
          x="56.4536"
          y="52.8281"
          width="28.207"
          height="80.1102"
          transform="rotate(166.167 56.4536 52.8281)"
          fill="#5F40CC"
        />
        <ellipse cx="21.6201" cy="23.7153" rx="11.5" ry="12" fill="#FCA9A1" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9292_115420">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6L44 38C44 41.3137 41.3137 44 38 44L6 44C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9292_115432)">
      <mask
        id="mask0_9292_115432"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="23"
        y="0"
        width="34"
        height="48"
      >
        <rect x="23" y="0.319672" width="34" height="47" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_9292_115432)">
        <rect x="23" y="0.319672" width="34" height="47" fill="#452CAB" />
        <circle cx="25" cy="21.3197" r="16" fill="#7AED5F" />
      </g>
      <mask
        id="mask1_9292_115432"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-11"
        y="-3"
        width="34"
        height="48"
      >
        <rect x="-11" y="-2.68033" width="34" height="47" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_9292_115432)">
        <rect x="-11" y="-2.68033" width="34" height="47" fill="#5F40CC" />
        <rect x="-11" y="-2.68031" width="34" height="47" fill="#7AED5F" />
        <circle cx="25" cy="21.3197" r="16" fill="#FFC63F" />
      </g>
      <mask
        id="mask2_9292_115432"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-29"
        y="9"
        width="67"
        height="65"
      >
        <rect
          x="-28.9297"
          y="38.7369"
          width="38.7449"
          height="54.8596"
          transform="rotate(-50 -28.9297 38.7369)"
          fill="#7AED5F"
        />
      </mask>
      <g mask="url(#mask2_9292_115432)">
        <path d="M-30 37.3197L-5.27163 7.84955L40 44.8197L12.2716 72.7898L-30 37.3197Z" fill="#FFE799" />
        <rect x="-8" y="8.31967" width="17" height="47" fill="#452CAB" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9292_115432">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6V38C44 41.3137 41.3137 44 38 44H6C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
  <>
    <g clipPath="url(#clip0_9292_115490)">
      <mask
        id="mask0_9292_115490"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-15"
        y="-2"
        width="34"
        height="52"
      >
        <path d="M18.9766 50L-15 45L-15 -2L18.9766 -2L18.9766 50Z" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_9292_115490)">
        <g style={{ mixBlendMode: 'multiply' }}>
          <path d="M19 45L-15 45L-15 -2.00001L45 1L19 45Z" fill="#003EB7" />
        </g>
        <circle cx="9" cy="33" r="21" transform="rotate(-180 9 33)" fill="#3F98FF" />
        <ellipse cx="22" cy="26" rx="12" ry="12" transform="rotate(-180 22 26)" fill="#FFE799" />
      </g>
      <mask
        id="mask1_9292_115490"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="18"
        y="0"
        width="34"
        height="47"
      >
        <path d="M52 47L18.25 47L18.25 3.59115e-05L52 2.18749e-05L52 47Z" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_9292_115490)">
        <rect x="52" y="47" width="34" height="47" transform="rotate(-180 52 47)" fill="#006CFF" />
        <path d="M52 47L18 47L18 -2.96774e-05L52 -2.77162e-05L52 47Z" fill="#0FBB0C" />
        <ellipse cx="14" cy="13" rx="32" ry="32" transform="rotate(-90 14 13)" fill="#FFAB00" />
        <ellipse cx="18" cy="5" rx="32" ry="32" transform="rotate(-90 18 5)" fill="#FFC63F" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9292_115490">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6L44 38C44 41.3137 41.3137 44 38 44L6 44C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,

  <>
    <g clipPath="url(#clip0_9292_117090)">
      <mask
        id="mask0_9292_117090"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-20"
        y="-12"
        width="134"
        height="102"
      >
        <path d="M113.346 18.4064L82.5669 89.6288L-19.9999 62.1461L-0.132511 -12L113.346 18.4064Z" fill="#7D58EE" />
      </mask>
      <g mask="url(#mask0_9292_117090)">
        <path d="M102.448 15.4319L82.567 89.6292L-19.9998 62.1464L21.6313 -67.0357L102.448 15.4319Z" fill="#F87173" />
        <rect x="12" y="-8" width="22" height="36" fill="#006CFF" />
        <circle cx="70.4133" cy="30.238" r="47.4444" transform="rotate(105 70.4133 30.238)" fill="#FFAB00" />
        <ellipse
          cx="61.2041"
          cy="5.20414"
          rx="27.1111"
          ry="27.1111"
          transform="rotate(105 61.2041 5.20414)"
          fill="#FFD666"
        />
      </g>
      <mask
        id="mask1_9292_117090"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-8"
        y="16"
        width="72"
        height="45"
      >
        <path d="M-7.95751 49.2587L-2.21992 16L63.4292 27.3254L57.6916 60.5841L-7.95751 49.2587Z" fill="#006CFF" />
      </mask>
      <g mask="url(#mask1_9292_117090)">
        <rect
          x="-7.95752"
          y="49.2587"
          width="26.4506"
          height="56.0499"
          transform="rotate(-80.212 -7.95752 49.2587)"
          fill="#FFE799"
        />
        <rect x="-8" y="11" width="20" height="36" fill="#002B93" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9292_117090">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0L38 0C41.3137 0 44 2.68629 44 6L44 38C44 41.3137 41.3137 44 38 44L6 44C2.68629 44 0 41.3137 0 38L0 6Z"
          fill="transparent"
        />
      </clipPath>
    </defs>
  </>,
];

export default squares;
